import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { AppService, DomainDataService } from '../../../../../../services';
import { PersonDialog } from '../../../../person-dialog';
import { FollowUpDialogService } from '../../follow-up-dialog.service';

@Component({
	selector: 'follow-up-details-part',
	standalone: true,
	imports: [
	],
	templateUrl: './follow-up-details.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './follow-up-details.part.scss'
})
export class FollowUpDetailsPart {

	private readonly domainData = inject(DomainDataService);
	private readonly followUpService = inject(FollowUpDialogService);
	private readonly util = inject(UtilityService);
	private readonly dialog = inject(DialogService);
	private readonly app = inject(AppService);

	public readonly followUpDetails = computed(() => {
		const details = this.followUpService.followUpDetails();
		if (details) {
			return {
				...details,
				dueByUTC: this.util.date.formatUTC(details.dueByUTC!, 'MM/DD/YYYY', 'No Time', 'en-US'),
				purpose: this.domainData.data().engagementPurposesMap[details.purposeId]?.name,
				closedUTC: details.closedUTC ? this.util.date.formatUTC(details.closedUTC, 'MM/DD/YYYY', 'No Time', 'en-US') : undefined,
				externalRoleName: this.domainData.data().engagementExternalRolesMap[details.externalRoleId]?.name,
				staffRoleName: this.domainData.data().staffRolesMap[details.staffRoleId]?.name,
				staffName: this.app.getStaffNameById(details.staffId),
				closedByStaffName: this.app.getStaffNameById(details.closedByStaffId),
			}
		}
		return undefined;
	});

	public openPersonDialog(personId: number) {
		this.dialog.showCustom(PersonDialog, { data: { personId, toEdit: false } }, 800, 800);
	}
}